import { Component, input } from '@angular/core';
import { AddressDto } from 'src/models/units/address.model';
import { EvAccordionComponent } from "ev-accordion";

@Component({
  selector: 'public-address-info',
  templateUrl: './public-address-info.component.html',
  styleUrl: './public-address-info.component.scss',
  imports: [EvAccordionComponent]
})
export class PublicAddressInfoComponent {
  addressInfo = input.required<AddressDto[]>();

  expanderClicked(): void {
  }
}
